import {useRouteMatch} from "react-router-dom";

export const useShowUI = () => {
	const profileMatch = !!useRouteMatch("/profile*");
	const idpMatch = !!useRouteMatch("/idp*");

	return profileMatch || idpMatch;
}

export const useShowMenu = () => {
	return !!useRouteMatch("/profile*");
}

const STATE_KEY = 'state';
export const NORMAL = 'normal';
export const START_LINK_IDP = 'startLinkIdp';

const encodeState = (state) => state ? new Buffer(JSON.stringify(state)).toString("base64") : '';

const decodeState = (b64) => b64 ? JSON.parse(new Buffer(b64, 'base64').toString('utf-8')) : {};

export const getApplicationState = () => decodeState(localStorage.getItem(STATE_KEY));

export const setApplicationState = (state) => localStorage.setItem(STATE_KEY, encodeState(state));
